import React, { useState } from 'react';
import { ICON } from './icon';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { questionItems } from './items';
import classNames from 'classnames';
import { PlusOutlined } from '@ant-design/icons';
import Collapse from './Collapse';

export default function MenuBar({ handleAddItem, selectItem, topValue }) {
    const [active, setActive] = useState(false);

    const SubMenu = () =>
        questionItems?.map((subItem, subIndex) => {
            return (
                <Tooltip placement="right" title={subItem.label} key={subIndex}>
                    <button
                        onClick={() => handleAddItem('item', subItem.key)}
                        type="button"
                        className={classNames(
                            'h-10 px-4 inline-flex items-center gap-x-2 text-sm font-medium focus:z-10',
                            'hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none',
                            'text-gray-800 border border-gray-200 bg-[#f4f4f5] transition-all duration-300',
                            'dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:bg-neutral-800'
                        )}
                    >
                        {subItem.icon}
                    </button>
                </Tooltip>
            );
        });

    const Menu = ({ item, index }) => {
        const Button = () => (
            <Tooltip placement="right" title={item.label} key={index}>
                <button
                    onClick={item.onClick}
                    type="button"
                    className={classNames(
                        'h-10 px-4 inline-flex items-center gap-x-2 text-sm font-medium focus:z-10',
                        'focus:outline-none disabled:opacity-50 disabled:pointer-events-none',
                        'border border-gray-200 bg-white text-purple-PHX shadow-sm transition-all duration-300',
                        'dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:bg-neutral-800',
                        {
                            'rounded-t-md': index === 0,
                            'rounded-b-md': index === items.length - 1,
                        }
                    )}
                >
                    {item.icon}
                </button>
            </Tooltip>
        );

        if (item.submenu) {
            return (
                <Collapse
                    onClick={item.onClick}
                    defaultOpen={active}
                    title={item.icon}
                >
                    <item.submenu />
                </Collapse>
            );
        } else return <Button />;
    };

    const MainMenu = ({ item }) => {
        return (
            <Tooltip placement="right" title={item.label}>
                <button
                    onClick={item.onClick}
                    type="button"
                    className={classNames(
                        'h-10 px-4 inline-flex items-center gap-x-2 text-sm font-medium focus:z-10',
                        'focus:outline-none disabled:opacity-50 disabled:pointer-events-none',
                        'border border-gray-200 bg-white text-purple-PHX shadow-sm transition-all duration-300',
                        'dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:bg-neutral-800',
                        'rounded-md'
                    )}
                >
                    {item.icon}
                </button>
            </Tooltip>
        );
    };

    const items = [
        {
            key: 'item',
            label: 'เพิ่มคำถาม',
            onClick: () => setActive(!active),
            icon: <PlusOutlined />,
            disabled: selectItem?.type === 'main' || !selectItem,
            submenu: SubMenu,
        },
        {
            key: 'group',
            label: 'เพิ่มส่วน',
            onClick: () => handleAddItem('group'),
            icon: ICON[2],
            disabled: false,
        },
    ];

    return (
        <SidePanelWrapper topValue={topValue}>
            <div className="max-w-xs flex flex-col shadow-sm">
                {selectItem?.type === 'main' ? (
                    <MainMenu item={items[1]} />
                ) : (
                    items.map((item, index) => (
                        <Menu key={item.label} index={index} item={item} />
                    ))
                )}
            </div>
        </SidePanelWrapper>
    );
}

const SidePanelWrapper = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
    top: 0;
    right: -62px;
    transform: ${(props) => `translateY(${props.topValue}px)`};
    @media (max-width: 425px) {
        z-index: 2;
        width: 100%;
        border-radius: 8px 8px 0 0;
        position: fixed;
        top: calc(100% - 48px);
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }
`;
